var pDOM = ['p', 0];
var paragraph = {
    content: 'inline*',
    group: 'block',
    marks: 'strong code em link strike subsup textColor typeAheadQuery underline confluenceInlineComment action annotation',
    parseDOM: [{ tag: 'p' }],
    toDOM: function () {
        return pDOM;
    },
};

export { paragraph };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/paragraph.js